import Vue from "vue";
import VueI18n from "vue-i18n";
import langEn from './en.js'
import zhHans from './zh.js'

Vue.use(VueI18n); // 全局挂载

const storedLocale = localStorage.getItem('locale')
const locale = storedLocale === 'en' ? 'en' : 'zh'
document.documentElement.lang = locale === 'en' ? 'en' : 'zh-CN'

export const i18n = new VueI18n({
    locale,
    fallbackLocale: 'zh',
    messages: {
        zh: zhHans, // 中文语言包
        en: langEn // 英文语言包
    }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js